export default __webpack_public_path__ + "2a77eb61ec7084e3733571a697328f7c.png";